import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const DEPRECIATION_CLASS_CRUD_ACTION_CONSTANTS =
	crudActionConstantsGenerator('DEPRECIATION_CLASS');
export const DEPRECIATION_CLASS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	DEPRECIATION_CLASS_CRUD_ACTION_CONSTANTS
);
